module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Yes, I know. We’re using the American spelling of Valor in the title and yet the stories use Canadian/UK spelling. Trust me, I’d have rather been able to use Canadian/UK spelling on the cover too but we’re trying to get it to match up with the new ebook series where we couldn’t change the interior to Canadian/UK spelling without having to charge you a whole lot more for each book. Which we didn’t want to do. Seriously, we didn’t. My biggest defining characteristic after Canadian is…um, frugal. Yeah, let’s call it frugal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I could use Canadian/UK spellings for these short stories because they’re a lot easier to change than eight books first published with US spelling. And I didn’t have to change “Long Time Passing,” because I wrote it for this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyway, we’re aware. And we recognize some people might find it a bit weird. But we saved you money, so yay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not That Kind of War,” “First In,” and “To Dust We Shall Return” all happen before the novels. Yes, I know most of you will be able to figure that out on your own, but in case someone new has wandered in, it’s only polite to mention it.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ab7cde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorsnote.vue
// module id = 66
// module chunks = 0